import { Languages } from 'libs/end-to-end/src/languages';
import { Phrases } from 'libs/end-to-end/src/phrases';
import { resolveLanguage } from 'libs/end-to-end/src/language';
import { useMemo } from 'react';
import { useObservation } from 'apps/sigma2-ui/src/state/observation';

/**
 * Hook for getting the current language phrases. This is a helper for getting a specific translation.
 */
export const useLanguage = (): Phrases => {
  const { myObservation } = useObservation();
  return useMemo(() => {
    const translationCode = myObservation?.translationPhrasingCode;

    return Languages[resolveLanguage(translationCode)];
  }, [myObservation]);
};
